(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cf-box"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('cf-box-builder'))customElements.define('cf-box-builder',class extends HTMLElement{connectedCallback(){if(this.bound)return;this.bound=true;this.items=[];this.target=3;this.addEventListener('change',e=>{if(!e.target.matches('select'))return;const item=this.items.find(i=>i.card===e.target.closest('.cf-box-card'));if(item){item.id=Number(e.target.value);item.price=Number(e.target.selectedOptions[0].dataset.price);item.title=item.card.querySelector('h3').textContent.trim()+' — '+e.target.selectedOptions[0].textContent.trim();this.render()}});this.addEventListener('change',e=>{if(this.submitting)return;if(!e.target.matches('input[type=radio]'))return;this.target=Number(e.target.value);this.items=this.items.slice(0,this.target);this.render()});this.addEventListener('click',e=>{if(this.submitting)return;const filter=e.target.closest('[data-filter]');if(filter){this.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===filter)));this.querySelectorAll('[data-category]').forEach(c=>c.hidden=filter.dataset.filter!=='all'&&!c.dataset.category.trim().split(/\s+/).includes(filter.dataset.filter));return}const add=e.target.closest('[data-add-piece]');if(add){const card=add.closest('.cf-box-card');const selectedIndex=this.items.findIndex(i=>i.card===card);if(selectedIndex!==-1){this.items.splice(selectedIndex,1);this.render();return}if(this.items.length>=this.target)return;if(add.dataset.demoPiece){this.items.push({id:add.dataset.demoPiece,title:add.dataset.title,demo:true});this.render();return}const select=card.querySelector('select');if(!select.value||select.selectedOptions[0].disabled||add.disabled)return;this.items.push({card,id:Number(select.value),price:Number(select.selectedOptions[0].dataset.price),title:add.dataset.title+(select.selectedOptions[0].textContent.trim()==='Default Title'?'':' — '+select.selectedOptions[0].textContent.trim())});this.render();return}const remove=e.target.closest('[data-remove-piece]');if(remove){this.items.splice(Number(remove.dataset.removePiece),1);this.render();return}if(e.target.closest('[data-submit-box]'))this.submit()});this.render()}
render(){const total=this.querySelector('[data-bundle-total]');if(total)total.textContent='Jewelry subtotal: '+new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:window.Shopify.currency.active}).format(this.items.reduce((n,i)=>n+(i.price||0),0)/100);this.querySelector('[data-selected-count]').textContent=this.items.length;this.querySelector('[data-box-target]').textContent=this.target;const list=this.querySelector('[data-selected-list]');list.replaceChildren();this.items.forEach((item,i)=>{const li=document.createElement('li'),text=document.createElement('span'),button=document.createElement('button');text.textContent=item.title;button.textContent='×';button.type='button';button.dataset.removePiece=i;button.setAttribute('aria-label','Remove '+item.title);li.append(text,button);list.append(li)});this.querySelector('[data-submit-box]').disabled=this.items.length!==this.target;this.querySelectorAll('[data-add-piece]').forEach(b=>{const selected=this.items.some(i=>i.card===b.closest('.cf-box-card'));b.classList.toggle('is-selected',selected);b.setAttribute('aria-pressed',String(selected));b.textContent=selected?'ADDED ✓':b.dataset.available==='false'?'SOLD OUT':'ADD TO BOX';b.disabled=b.dataset.available==='false'||(!selected&&this.items.length>=this.target)});this.querySelector('[data-submit-box]').textContent=this.items.length===this.target?'Create bundle':'Choose '+(this.target-this.items.length)+' more';this.querySelector('[data-box-status]').textContent=this.items.length>this.target?'Remove pieces to match your box size.':`${this.items.length} of ${this.target} pieces selected.`}
async submit(){if(this.submitting)return;const button=this.querySelector('[data-submit-box]'),status=this.querySelector('[data-box-status]');if(this.items.length!==this.target)return;if(this.items.some(i=>i.demo)){status.textContent='Placeholder box preview complete. Real products will be connected before launch.';return}this.submitting=true;button.disabled=true;try{const cartResponse=await fetch('/cart.js',{cache:'no-store'});if(!cartResponse.ok)throw new Error('Unable to check your cart. Please try again.');const cart=await cartResponse.json();if(cart.item_count+this.items.length>100)throw new Error('Orders are limited to 100 items. Remove items from your cart before adding this box.');const quantities=new Map;this.items.forEach(i=>quantities.set(i.id,(quantities.get(i.id)||0)+1));const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-Sunday-Soul-Bundle':'1'},body:JSON.stringify({items:Array.from(quantities,([id,quantity])=>({id,quantity,properties:{_SundaySoulBundle:`${this.target} pieces`}}))})});const data=await response.json();if(!response.ok)throw new Error(data.description||'Please try again.');window.location.assign(this.dataset.cartUrl)}catch(error){status.textContent=error.message;this.submitting=false;button.disabled=false}}});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-content"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('click',event=>{const button=event.target.closest('[data-rail-prev],[data-rail-next]');if(!button)return;const rail=button.closest('.cf-content').querySelector('[data-rail]');if(!rail)return;rail.scrollBy({left:rail.clientWidth*(button.hasAttribute('data-rail-prev')?-1:1),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cf-header"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const back = event.target.closest('.cf-mobile-submenu__back');
  if (!back) return;
  const submenu = back.closest('details');
  submenu.open = false;
  submenu.querySelector('summary').focus();
});
document.addEventListener('toggle', (event) => {
  if (!event.target.matches('.cf-mobile-menu') || event.target.open) return;
  event.target.querySelectorAll('.cf-mobile-submenu').forEach((submenu) => { submenu.open = false; });
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
